var QuizContainer = (() => {
	var closeModal = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container]');
		if (!bigcontainer) return;
		const modal = bigcontainer.querySelector('[js-quiz-modal]');
		modal.classList.remove('open');
		pauseVideo(container);
	}
	var openModal = (container, modalNumber) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container');
		if (!bigcontainer) return;
		const modal = bigcontainer.querySelector('[js-quiz-modal]');
		if (!modal) return;
		modal.classList.add('open');
		modal.setAttribute('data-modal-number', modalNumber);
	}
	var pauseVideo = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container');
		if (!bigcontainer) return;
		const modal = bigcontainer.querySelector('[js-quiz-modal]');
		if (!modal) return;
		modal.querySelectorAll('[js-modal-video] video').forEach(video => {
			video.pause();
		});
		const videoWrapper = modal.querySelector('[js-modal-video-wrapper]');
		if (videoWrapper) videoWrapper.classList.remove('playing');
	}
	var playVideo = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container');
		if (!bigcontainer) return;
		const modal = bigcontainer.querySelector('[js-quiz-modal]');
		if (!modal) return;
		const modalNumber = modal.getAttribute('data-modal-number');
		const video = modal.querySelector(`[js-modal-video][data-number="${modalNumber}"] video`);
		if (!video) return;
		video.play();
		const videoWrapper = modal.querySelector('[js-modal-video-wrapper]');
		if (videoWrapper) videoWrapper.classList.add('playing');
	}
	var back = (container) => {
		if (!container) {
			console.log('[quiz-container] issue');
			return;
		}
		container.setAttribute('data-value', container.getAttribute('data-value').slice(0, container.getAttribute('data-value').lastIndexOf('-')));
	}
	var initBackButtons = (container) => {
		if (!container) {
			console.log('[quiz-container] issue');
			return;
		}
		container.querySelectorAll('[js-back]').forEach(element => {
			element.addEventListener('click', () => {
				back(container);
			});
		});
	}
	var initOptions = (container) => {
		container.querySelectorAll('[js-option]').forEach(option => {
			option.addEventListener('click', () => {
				var value = option.getAttribute('data-value');
				const stateWrapper = option.closest('[js-state-wrapper]');
				if (!stateWrapper) {
					console.log('[js-state-wrapper] issue');
					return;
				}
				const checkbox = stateWrapper.querySelector('[js-checkbox]');
				if (checkbox) {
					value = value + checkbox.getAttribute('data-value');
				}
				if (container.getAttribute('data-value') != '') {
					value = container.getAttribute('data-value') + '-' + value;
				}
				container.setAttribute('data-value', value);
				localStorage.setItem('quiz-data-value', value);
			});
		});
	}
	var initCheckbox = (container) => {
		container.querySelectorAll('[js-checkbox-option]').forEach(element => {
			element.addEventListener('click', () => {
				const checkbox = element.closest('[js-checkbox]');
				if (!checkbox) {
					console.log('[js-checkbox] issue');
					return;
				}
				checkbox.setAttribute('data-value', element.getAttribute('data-value'));
			});
		});
		container.querySelectorAll('[js-checkbox-trigger]').forEach(element => {
			element.addEventListener('click', () => {
				const checkbox = element.closest('[js-checkbox]');
				if (!checkbox) {
					console.log('[js-checkbox] issue');
					return;
				}
				if (checkbox.getAttribute('data-value') == '1') {
					checkbox.setAttribute('data-value', '2');
				} else {
					checkbox.setAttribute('data-value', '1');
				}
			});
		});
	}
	var initChooseButtons = (container) => {
		container.querySelectorAll('[js-choose-button]').forEach(element => {
			element.classList.remove('chosen');
		});
		fetch('/cart.js', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		.then(response => response.json())
		.then(cart => {
			cart.items.forEach(item => {
				container.querySelectorAll('[js-choose-button]').forEach(element => {
					let dataProductIds = element.getAttribute('data-product-ids');
					if (dataProductIds && dataProductIds != '') {
						const productIds = dataProductIds.split(',');
						productIds.forEach(productId => {
							if (String(item.product_id) == String(productId)) {
								element.classList.add('chosen');
                                const smallOptions = element.closest('.small-options');
								if (smallOptions) {
									let all_chosen = true;
									smallOptions.querySelectorAll('.small-option:has([js-choose-button]):not(:has(.optional-badge))').forEach(smallOption => {
										if (smallOption.querySelector('[js-choose-button]').classList.contains('chosen') == false) {
											all_chosen = false;
										}
									});
									if (all_chosen) {
										smallOptions.querySelectorAll('.small-option:has(.optional-badge) [js-choose-button]').forEach(button => {
											button.classList.add('chosen');
										});
									}
								}
							}
						});
					}
				});
			});
		})
		.catch(error => {
			console.error('Error fetching cart:', error);
		});
	}
	var initState = (container) => {
		let value = localStorage.getItem('quiz-data-value');

		if (value) {
			container.setAttribute('data-value', value);
		}

		initChooseButtons(container);
	}
	var initFooterDescriptionTrigger = (container) => {
		if (!container) return;
		container.querySelectorAll('[js-video-modal-trigger').forEach(element => {
			element.addEventListener('click', () => {
				openModal(container, element.getAttribute('data-target-modal'));
			});
		});
	}
	var initCloseModalButtons = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container]');
		if (!bigcontainer) return;
		bigcontainer.querySelectorAll('[js-close]').forEach(element => {
			element.addEventListener('click', () => {
				closeModal(container);
			});
		});
	}
	var initVideoButtons = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container]');
		if (!bigcontainer) return;
		bigcontainer.querySelectorAll('[js-modal-video-play]').forEach(element => {
			element.addEventListener('click', () => {
				playVideo(container);
			});
		});
		bigcontainer.querySelectorAll('[js-modal-video-pause]').forEach(element => {
			element.addEventListener('click', () => {
				pauseVideo(container);
			});
		});
		bigcontainer.querySelectorAll('[js-modal-video] video').forEach(video => {
			video.addEventListener('ended', () => {
				playVideo(container);
				pauseVideo(container);
			});
		});
	}
	var initialize = () => {
		document.querySelectorAll('[quiz-container]').forEach(container => {
			initBackButtons(container);
			initOptions(container);
			initCheckbox(container);
			initState(container);
			initFooterDescriptionTrigger(container);
			initCloseModalButtons(container);
			initVideoButtons(container);
		});
	}
	return {
		init: initialize,
		initChooseButtons: initChooseButtons
	}
})();

var MhQTYText = (() => {
	let mainElement = null;
	var show = () => {
		if (!mainElement) return;
		mainElement.classList.remove('!tw-hidden');
	}
	var hide = () => {
		if (!mainElement) return;
		mainElement.classList.add('!tw-hidden');
	}
	var formatPrice = (value) => {
		value = Number(value);
		let A = parseInt(value / 100.0);
		let B = parseInt(value % 100.0);
		B = (B<10)?('0'+B):B;
		return `${A},${B}`;
	}
	var update = (value) => {
		value = Number(value);
		const sqvalue = Math.ceil(value * Number(mainElement.getAttribute('data-sqrm-multiplier')));
		const price = formatPrice(Math.ceil(sqvalue * Number(mainElement.getAttribute('data-price')))) + mainElement.getAttribute('data-currency-symbol');
		const comparePrice = formatPrice(Math.ceil(sqvalue * Number(mainElement.getAttribute('data-compare-price')))) + mainElement.getAttribute('data-currency-symbol');
		const infoElement = mainElement.querySelector('.mh-qty-text__pieces-info');
		if (!infoElement) return;
		infoElement.innerHTML = String(infoElement.getAttribute('data-template')).replace('{{ pieces }}', sqvalue);
		const comparePriceElement = mainElement.querySelector('[js-compare-price]');
		const priceElement = mainElement.querySelector('[js-price]');
		if (!comparePriceElement || !priceElement) return;
		comparePriceElement.innerHTML = comparePrice;
		priceElement.innerHTML = price;
	}
	var rerender = () => {
		if (!mainElement) return;
		const specialPricePerPiece = (document.querySelector('[js-data-special-price-per-piece]'))?document.querySelector('[js-data-special-price-per-piece]').getAttribute('data-value'):0;
		const comparePricePerPiece = (document.querySelector('[js-data-compare-price-per-piece]'))?document.querySelector('[js-data-compare-price-per-piece]').getAttribute('data-value'):0;
		const sqrmMultiplier = (document.querySelector('[js-data-sqrm-multiplier]'))?document.querySelector('[js-data-sqrm-multiplier]').getAttribute('data-value'):0;
		mainElement.setAttribute('data-sqrm-multiplier', sqrmMultiplier);
		mainElement.setAttribute('data-other', sqrmMultiplier);
		mainElement.setAttribute('data-price', specialPricePerPiece);
		mainElement.setAttribute('data-compare-price', comparePricePerPiece);
		// If collection-and-pdp-ab-test is finished, remove here code
		// start temp code
		document.querySelectorAll('.mh-qty-text.collection-and-pdp-ab-test-a').forEach(element => {
			element.setAttribute('data-sqrm-multiplier', sqrmMultiplier);
			element.setAttribute('data-other', sqrmMultiplier);
			element.setAttribute('data-price', specialPricePerPiece);
			element.setAttribute('data-compare-price', comparePricePerPiece);
		});
		// end temp code
		if (document.querySelector('.quantity--square>input')) {
			update(document.querySelector('.quantity--square>input').getAttribute('data-numb-value'));
		}
	}
	var initialize = () => {
		mainElement = document.querySelector('[js-mh-qty-text]');
		document.querySelectorAll('.mh-qty-switch__label').forEach(element => {
			element.addEventListener('click', () => {
				if (element.getAttribute('data-type') == 'squarem') {
					show();
				} else {
					hide();
				}
			});
		});
		document.querySelectorAll('.quantity--square>input').forEach(element => {
			element.addEventListener('blur', () => {
				update(element.getAttribute('data-numb-value'));
				MhQTYTextFliped.update(Math.ceil(Number(element.getAttribute('data-numb-value')) * Number(mainElement.getAttribute('data-sqrm-multiplier'))))
			});
		});
	}
	return {
		init: initialize,
		update: update,
		rerender: rerender
	}
})();

var MhQTYTextFliped = (() => {
	let mainElement = null;
	var show = () => {
		if (!mainElement) return;
		mainElement.classList.remove('!tw-hidden');
	}
	var hide = () => {
		if (!mainElement) return;
		mainElement.classList.add('!tw-hidden');
	}
	var formatPrice = (value) => {
		value = Number(value);
		let A = parseInt(value / 100.0);
		let B = parseInt(value % 100.0);
		B = (B<10)?('0'+B):B;
		return `${A},${B}`;
	}
	var update = (value) => {
		value = Number(value);
		const sqvalue = parseInt(value / Number(mainElement.getAttribute('data-sqrm-multiplier')) * 100) / 100.0;
		const price = formatPrice(Math.ceil(value * Number(mainElement.getAttribute('data-price')))) + mainElement.getAttribute('data-currency-symbol');
		const comparePrice = formatPrice(Math.ceil(value * Number(mainElement.getAttribute('data-compare-price')))) + mainElement.getAttribute('data-currency-symbol');
		const infoElement = mainElement.querySelector('.mh-qty-text__pieces-info');
		if (!infoElement) return;
		infoElement.innerHTML = String(infoElement.getAttribute('data-template')).replace('{{ pieces }}', sqvalue);
		const comparePriceElement = mainElement.querySelector('[js-compare-price]');
		const priceElement = mainElement.querySelector('[js-price]');
		if (!comparePriceElement || !priceElement) return;
		comparePriceElement.innerHTML = comparePrice;
		priceElement.innerHTML = price;
	}
	var rerender = () => {
		if (!mainElement) return;
		const specialPricePerPiece = (document.querySelector('[js-data-special-price-per-piece]'))?document.querySelector('[js-data-special-price-per-piece]').getAttribute('data-value'):0;
		const comparePricePerPiece = (document.querySelector('[js-data-compare-price-per-piece]'))?document.querySelector('[js-data-compare-price-per-piece]').getAttribute('data-value'):0;
		const sqrmMultiplier = (document.querySelector('[js-data-sqrm-multiplier]'))?document.querySelector('[js-data-sqrm-multiplier]').getAttribute('data-value'):0;
		mainElement.setAttribute('data-sqrm-multiplier', sqrmMultiplier);
		mainElement.setAttribute('data-other', sqrmMultiplier);
		mainElement.setAttribute('data-price', specialPricePerPiece);
		mainElement.setAttribute('data-compare-price', comparePricePerPiece);
		if (document.querySelector('quantity-input>input[name="quantity"]')) {
			update(document.querySelector('quantity-input>input[name="quantity"]').value);
		}
	}
	var initialize = () => {
		mainElement = document.querySelector('[js-mh-qty-text-fliped]');
		document.querySelectorAll('.mh-qty-switch__label').forEach(element => {
			element.addEventListener('click', () => {
				if (element.getAttribute('data-type') == 'piece') {
					show();
				} else {
					hide();
					document.querySelectorAll('quantity-input>input[name="quantity"]').forEach(quantityElement => {
						const updatedValue = Math.ceil(Math.floor(quantityElement.value / Number(mainElement.getAttribute('data-sqrm-multiplier'))) * Number(mainElement.getAttribute('data-sqrm-multiplier')));
						quantityElement.value = updatedValue;
						update(updatedValue);
					});
				}
			});
		});
		document.querySelectorAll('quantity-input>input[name="quantity"]').forEach(element => {
			element.addEventListener('blur', () => {
				update(element.value);
				MhQTYText.update(Math.floor(element.value / Number(mainElement.getAttribute('data-sqrm-multiplier'))));
			});
		});
	}
	return {
		init: initialize,
		update: update,
		rerender: rerender
	}
})();


var MenuDrawerSearchApp = (() => {
	var searchElement = null;
	var open = () => {
		if (!searchElement) return;
		searchElement.classList.add('active');
	}
	var close = () => {
		if (!searchElement) return;
		searchElement.classList.remove('active');
	}
	var initialize = () => {
		searchElement = document.querySelector('[js-menu-drawer-search]');
		document.querySelectorAll('[js-menu-drawer-search-trigger]').forEach(element => {
			element.addEventListener('click', () => {
				open();
			});
		});
		if (searchElement) {
			document.addEventListener('click', (e) => {
				if (!(searchElement && searchElement.contains(e.target)) && !(document.querySelector('[js-menu-drawer-search-trigger]') && document.querySelector('[js-menu-drawer-search-trigger]').contains(e.target))) {
					close();
				}
			});
		}
	}
	return {
		init: initialize
	}
})();


class MenuAccordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('summary+div');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'ease-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}

var SubcategoryModalApp = (() => {
	var open = (modal) => {
		if (!modal) return;
		modal.classList.add('open');
	}

	var close = (modal) => {
		if (!modal) return;
		modal.classList.remove('open');
	}

	var initialize = () => {
		document.querySelectorAll('[js-subcategory-modal-trigger]').forEach(element => {
			element.addEventListener('click', () => {
				const container = element.closest('[js-container]');
				if (!container) return;
				open(container.querySelector('[js-subcategory-modal]'));
			});
		});
		document.querySelectorAll('[js-subcategory-modal] [js-close]').forEach(element => {
			element.addEventListener('click', () => {
				close(element.closest('[js-subcategory-modal]'));
			});
		});
	}
	return {
		init: initialize
	}
})();

var App = (() => {
	var initialize = () => {
		QuizContainer.init();
        MhQTYText.init();
		MhQTYTextFliped.init();
        MenuDrawerSearchApp.init();
		document.querySelectorAll('.menu-drawer__navigation-container details').forEach((el) => {
			new MenuAccordion(el);
		});
        SubcategoryModalApp.init();
	}
	return {
		init: initialize
	}
})();

document.addEventListener('DOMContentLoaded', () => {
	App.init();
});

document.addEventListener('cart-item:quantity-updated', () => {
	document.querySelectorAll('[quiz-container]').forEach(container => {
		QuizContainer.initChooseButtons(container);
	});
});

document.addEventListener('cart:updated', () => {
	document.querySelectorAll('[quiz-container]').forEach(container => {
		QuizContainer.initChooseButtons(container);
	});
});

document.addEventListener('variant:change:end', () => {
	MhQTYText.rerender();
	MhQTYTextFliped.rerender();
});